t = require('views/internal/teacup-with-helpers')('announcement')

classesForType = (type) ->
  classes = ['announcement']
  if type
    classes.push ['announcement', type].join('-')
  classes.join(' ')

module.exports = t.renderable ({ url: href, title, html, type }) ->
  t.div { class: classesForType(type) }, ->
    t.h3 '.announcement-header', ->
      if href?
        t.a '.announcement-header-link', { target: '_blank', href }, ->
          t.text title
      else
        t.text title
      return

    t.p ->
      t.raw html

    if !href?
      return
    t.p '.quiet', ->
      t.a { href, target: '_blank' }, ->
        t.format 'read-more-ellipsis'
    return




// WEBPACK FOOTER //
// ./app/scripts/views/templates/announcement.coffee